import React, { Component } from "react";
import { Box, Typography } from "@mui/material";
import Utils from "../../../provider/Utils";
// import { motion } from "framer-motion";
class WideMeter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mercuryHeight: "0%", // Start at zero
    };
  }

  componentDidMount() {
    const { goal, raised } = this.props;

    const percentage = goal > 0 ? Math.min((raised / goal) * 100, 100) : 0;
    const heightInPx = (270 * percentage) / 100;
    setTimeout(() => {
      this.setState({ mercuryHeight: heightInPx });
    }, 500);
  }

  componentDidUpdate(prevProps) {
    const { goal, raised } = this.props;
    if (prevProps.goal !== goal || prevProps.raised !== raised) {
      const percentage = goal > 0 ? Math.min((raised / goal) * 100, 100) : 0;
      const heightInPx = (270 * percentage) / 100;
      this.setState({ mercuryHeight: heightInPx });
    }
  }

  render() {
    const {
      goal,
      raised,
      color,
      isShowGoalAmount,
      measureType,
      is3dEffect,
      meterFontColor,
    } = this.props;
    return (
      <>
        {/* Thermometer Cap */}
        <Box
          sx={{
            top: "4px",
            height: "41px",
            width: "82px",
            left: "29px",
            zIndex: "999",
            background: "#ddd",
            borderRadius: "50px 50px 0px 0px",
            position: "relative",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column-reverse",
            border: "12px solid #ccc",
            borderBottom: "none",
            transform: "rotateX(10deg)",
            transformStyle: "preserve-3d",
            perspective: "1000px",
            boxShadow: is3dEffect
              ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4), inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
              : "none",
          }}
        ></Box>
        <Box
          sx={{ textAlign: "center", position: "relative", height: "270px" }}
        >
          {/* Goal Labels */}
          {isShowGoalAmount && (
            <Box
              sx={{
                position: "absolute",
                alignItems: "end",
                right: "118px",
                // top: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "270px",
                color: meterFontColor,
                fontWeight: "400",
              }}
            >
              {measureType?.type === "% Meter" ? (
                <>
                  {[1, 0.8, 0.6, 0.4, 0.2, 0].map((value, index) => {
                    return (
                      <Typography
                        key={index}
                        variant="body2"
                        sx={{
                          visibility: value === 0 ? "hidden" : "visible",
                        }}
                      >
                        {`${(value * 100).toFixed(0)}%`}
                      </Typography>
                    );
                  })}
                </>
              ) : (
                <>
                  {[1, 0.8, 0.6, 0.4, 0.2, 0].map((value, index) => {
                    const amount = goal * value;
                    return (
                      <Typography
                        key={index}
                        variant="body2"
                        sx={{
                          visibility: amount === 0 ? "hidden" : "visible",
                        }}
                      >
                        ${Utils.formatCompactNumber(amount)}
                      </Typography>
                    );
                  })}
                </>
              )}
            </Box>
          )}
          {/* Thermometer Container */}
          <Box
            sx={{
              height: "270px",
              width: "82px",
              left: "29px",
              zIndex: "999",
              background: "#ddd",
              // borderRadius: "50px 50px 0px 0px",
              position: "relative",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column-reverse",
              border: "12px solid #ccc",
              borderTop: "none",
              borderBottom: "none",
              transform: "rotateX(10deg)",
              transformStyle: "preserve-3d",
              perspective: "1000px",
              boxShadow: is3dEffect
                ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                : "none",
              // boxShadow:
              //   "inset -4px 0 8px rgba(0, 0, 0, 0.3),    inset 4px 0 8px rgba(0, 0, 0, 0.3)",
            }}
          >
            {/* Mercury Level */}
            {isShowGoalAmount && (
              <Box
                sx={{
                  position: "absolute",
                  left: "-15px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "270px",
                  color: "#fff",
                  fontWeight: "800",
                }}
              >
                {[...Array(50)].map((_, index) => (
                  <Box
                    key={index}
                    sx={{
                      position: "absolute",
                      bottom: `${index * 4}%`, // 5% interval
                      left: "10px",
                      width: index % 5 === 0 ? "16px" : "10px",
                      height: index % 5 === 0 ? "1px" : "0.5px",
                      background: "#000",
                      opacity: index % 5 === 0 ? 0.8 : 0.6,
                    }}
                  />
                ))}
              </Box>
            )}
            <Box
              sx={{
                width: "100%",
                background: color,
                transition: "height 1.5s ease-in-out",
                height: `${this.state.mercuryHeight}px`,
                boxShadow: is3dEffect
                  ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                  : "none",
              }}
            />
          </Box>
          <Box
            sx={{
              background: color,
              top: "-4px",
              height: "17px",
              width: "82px",
              left: "29px",
              zIndex: "999",
              // background: "#ddd",
              // borderRadius: "50px 50px 0px 0px",
              position: "relative",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column-reverse",
              border: "12px solid #ccc",
              borderTop: "none",
              borderBottom: "none",
              transform: "rotateX(10deg)",
              transformStyle: "preserve-3d",
              perspective: "1000px",
              boxShadow: is3dEffect
                ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                : "none",
              // boxShadow:
              //   "inset -4px 0 8px rgba(0, 0, 0, 0.3),    inset 4px 0 8px rgba(0, 0, 0, 0.3)",
            }}
          ></Box>
          <Box
            sx={{
              width: "140px",
              height: "140px",
              background: color,
              borderRadius: "50%",
              border: "12px solid #ccc",
              position: "relative",
              top: "-25px",
              left: "0%",
              transform: "rotateX(10deg)",
              transformStyle: "preserve-3d",
              perspective: "1000px",
              //   boxShadow:
              //     "inset 0 0 10px rgba(0, 0, 0, 0.2), 0 4px 6px rgba(0, 0, 0, 0.3)",
              boxShadow: is3dEffect
                ? "inset -4px 0 8px rgba(0, 0, 0, 0.4), inset 4px 0 8px rgba(0, 0, 0, 0.4)"
                : "none",
              "&::before": {
                content: '""', // ✅ Required for ::before to show
                position: "absolute",
                top: "16%",
                left: "5%",
                width: "60%",
                height: "47%",
                background:
                  "radial-gradient(circle, rgba(255,255,255,0.7) 0%, transparent 90%)",
                clipPath: "ellipse(60% 60% at 60% 60%)",
                borderRadius: "50%",
                filter: "blur(1px)",
                transform: "rotate(-47deg)",
                zIndex: 2,
              },
            }}
          />

          {/* Tooltip with Raised Amount */}
          <Box
            sx={{
              position: "absolute",
              top: `${270 - this.state.mercuryHeight}px`,
              left: "110px",
              width: "100%",
              display: "-webkit-box",
              fontWeight: "bold",
              color: meterFontColor,
              fontSize: "18px",
              // padding: "3px 10px",
              // borderRadius: "5px",
              // boxShadow: "0px 0px 5px rgba(0,0,0,0.2)",
              transform: "translateY(-50%)",
              transition: "top 1.5s ease-in-out",
            }}
          >
            <i
              class="fa fa-caret-left"
              aria-hidden="true"
              style={{
                alignSelf: "center",
                padding: "0 5px",
              }}
            ></i>
            <Typography
              variant="body2"
              className="fw-bold text-start"
              style={{ width: "-webkit-fill-available", lineHeight: raised?.toLocaleString()?.length > 6 ? "1" : "0.6" }}
            >
              Raised:{" "}
              <span style={{ fontSize: "21px" }}>
                ${raised.toLocaleString()}
              </span>
            </Typography>
          </Box>
        </Box>
      </>
    );
  }
}

export default WideMeter;
